module.exports = __webpack_public_path__ + "img/corporate_history.f539391.png";